import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2011"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.44 13.288H1.56a.7.7 0 1 0 0 1.4h12.88a.7.7 0 1 0 0-1.4zM1.56 12.252h12.88a.7.7 0 1 0 0-1.4h-3.992l.38-1.291 3.724-1.833a.224.224 0 0 0-.037-.417l-3.44-.987c-.008-.003-.013-.009-.021-.011a.7.7 0 0 0-.869.475l-1.123 3.817a.72.72 0 0 0-.022.247H3.276l.694-2.364 9.247-4.553a.5.5 0 0 0-.083-.928L5.502.818C5.498.816 5.495.813 5.491.812L5.477.811 5.435.798l-.002.008a.694.694 0 0 0-.811.48l-2.805 9.565H1.56a.7.7 0 1 0 0 1.401z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }